<template>
  <div>
    <p v-if="company == 'Portal' && mobile" v-html="$t(portalMobileTranslateId)">x-Welcome to MyPortal Mobile</p>
    <p v-else-if="company == 'Portal' && premium" v-html="$t(portalPremiumTranslateId)">x-Welcome to MyPortal Premium</p>
    <p v-else-if="company == 'Portal'" v-html="$t(portalDefaultTranslateId)">x-Welcome to MyPortal Basic</p>
    <p v-else-if="['US', 'CA'].includes(country)" v-html="$t('ml_107025', { company: company })">
      x-Save time online... with your account management system
    </p>
    <p v-else-if="mobile" v-html="$t('ml_107002', { company: company })">x-Welcome to MyAP Mobile</p>
    <p v-else-if="premium" v-html="$t('ml_107005', { company: company })">x-Welcome to MyAP Premium</p>
    <p v-else v-html="$t('ml_107003', { company: company })">x-Welcome to MyAP Basic</p>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
  props: {
    mobile: {
      type: Boolean,
      default: false
    },
    premium: {
      type: Boolean,
      default: false
    },
    company: {
      type: String,
      default: 'AirProducts'
    },
    country: {
      type: String,
      default: null
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    portalMobileTranslateId() {
      switch (this.user.salesOrg) {
        case "GB46":
          return "ml_132929";
        case "GB47":
          return "ml_132930";
        case "GB49":
          return "ml_132931";
      }
    },
    portalPremiumTranslateId() {
      switch (this.user.salesOrg) {
        case "GB46":
          return "ml_132932";
        case "GB47":
          return "ml_132933";
        case "GB49":
          return "ml_132934";
      }
    },
    portalDefaultTranslateId() {
      switch (this.user.salesOrg) {
        case "GB46":
          return "ml_132925";
        case "GB47":
          return "ml_132926";
        case "GB49":
          return "ml_132927";
      }
    },
  },
}
</script>
